import { NgModule } from "@angular/core";
import { ScientificArchiveMapComponent } from "./scientific-archive-map.component";
import { CardModule } from "primeng/card";
import { CardHeaderModule } from "../card-header/card-header.module";
import { ArcGisMapComponent } from "src/app/components/arcgis-map/arcgis-map.component";


@NgModule({
    imports: [
        CardModule,
        CardHeaderModule,
        ArcGisMapComponent
    ],
    declarations: [
        ScientificArchiveMapComponent
    ],
    exports: [
        ScientificArchiveMapComponent
    ]
})
export class ScientificArchiveMapModule { }